import { css, useTheme } from "@emotion/react";
import { omit } from "lodash/fp";
import merge from "lodash/fp/merge";
import { Fragment, useContext, useState } from "react";

import {
  Icon,
  Heading,
  Stack,
  TypographyBlock,
  useThemeProps,
  Section,
  handleComponentsProp,
  useIsSameBackground,
  generateUniqueId,
} from "../../wsui/base";

import PostsModuleArchiveLink from "./PostsModuleArchiveLink.jsx";
import postsModuleContext from "./postsModuleContext";
import PostsModuleItem from "./PostsModuleItem.jsx";

export default function PostsModuleListLayout(props) {
  // eslint-disable-next-line no-unused-vars
  let theme = useTheme();
  props = useThemeProps({ props, name: "MunicipioPostsModuleListLayout" });
  let {
    title,
    titleIcon,
    titleIconProps = { size: 8 },
    description,
    archiveLink,
    items,
    spacing = 4,
    components,
    headingVariant,
    itemVariant = "teaser",
    itemColor,
    divider = true,
    headingId,
    align,
    ...restProps
  } = omit(["gridMaxColumns"], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const archiveAlign =
    contentAlign === "right"
      ? "flex-end"
      : contentAlign === "center"
        ? "center"
        : "flex-start";
  components = handleComponentsProp(components, { Item: PostsModuleItem });
  let { Item } = components;

  let parentOwnerState = useContext(postsModuleContext);
  let { visibleFields } = parentOwnerState;
  let ownerState = merge(parentOwnerState, {
    title,
    description,
    archiveLink,
    items,
    visibleFields,
    itemVariant,
    itemColor,
  });

  let isSameBackground = useIsSameBackground(itemColor);
  divider = !itemColor || isSameBackground ? divider : false;

  const [defaltHeadingId] = useState(
    () => `module-heading-${generateUniqueId()}`,
  );
  headingId = headingId || defaltHeadingId;

  const MaybeSection = title ? Section : Fragment;

  return (
    <postsModuleContext.Provider value={ownerState}>
      <div {...restProps}>
        {title && (
          <Heading
            variant={headingVariant}
            marginAfter
            id={headingId}
            css={css`
              display: flex;
              gap: 0.5em;
              align-items: start;
            `}
          >
            {titleIcon && (
              <Icon
                name={titleIcon}
                css={css`
                  align-self: center;
                  flex: none;
                `}
                {...titleIconProps}
              />
            )}
            {title}
          </Heading>
        )}
        {description && (
          <TypographyBlock marginAfter align="left">{description}</TypographyBlock>
        )}
        <MaybeSection>
          <Stack spacing={spacing} divider={divider}>
            {items.map((item, index) => (
              <Item
                key={index}
                item={item}
                visibleFields={visibleFields}
                variant={itemVariant}
                align={contentAlign}
              />
            ))}
          </Stack>
        </MaybeSection>
        {archiveLink && (
          <PostsModuleArchiveLink
            align={archiveAlign}
            css={css`
              margin-top: ${theme.getLength(6)};
            `}
            {...archiveLink}
          />
        )}
      </div>
    </postsModuleContext.Provider>
  );
}
